/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:46:01
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginDnd from 'bee-dnd';
import { getSysFieldid } from '@platform/api';

require('bee-dnd/build/Dnd.css');

export default class Dnd extends Component {
	render() {
		let { fieldid, ...others } = this.props;
		return <OriginDnd {...others} fieldid={getSysFieldid(fieldid)} />;
	}
}

Dnd.GridLayout = OriginDnd.GridLayout;
